import { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import settingServiceSelectors from '../selectors';
import settingServiceActions from '../actions';

const useGetTemplatePrintPayroll = (lazy?: boolean) => {
  const dispatch = useAppDispatch();
  const data = settingServiceSelectors.getTemplatePrintPayroll();

  const mutate = () => {
    dispatch(settingServiceActions.getTemplatePrintPayroll.fetch());
  };

  useEffect(() => {
    if (!lazy) {
      mutate();
    }
  }, []);

  return { data, mutate } as const;
};

export default useGetTemplatePrintPayroll;
